import { render } from "./Button.vue?vue&type=template&id=8bc7c966"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=8bc7c966&lang=css"

import exportComponent from "/Users/pato/Documents/vencejos/codigoqr/public/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bc7c966"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bc7c966', __exports__)) {
    console.log('reload')
    api.reload('8bc7c966', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=8bc7c966", () => {
    console.log('re-render')
    api.rerender('8bc7c966', render)
  })

}


export default __exports__